import { z } from "zod";

export const loginSchema = z.object({
  username: z.string().trim().min(1, "Поле обязательно").max(100, "Не более 100 символов"),
  password: z.string().trim().min(1, "Поле обязательно").max(100, "Не более 100 символов"),
});
